export default {
  install(Vue, options) {
    const defaultOptions = {
      LOCALE: "en-US",
      DEFAULT_CURRENCY: "USD"
    };

    // merge default options with arg options
    let userOptions = { ...defaultOptions, ...options };

    Vue.prototype.$formatCurrency = function(value, currency) {
      return new Intl.NumberFormat(userOptions.LOCALE, {
        style: "currency",
        currency: currency ? currency : userOptions.DEFAULT_CURRENCY
      }).format(value);
    };

    Vue.prototype.$addressComponentsFromGmapPlace = function(placeObj) {
      // console.log(placeObj);
      let result = {
        address1: placeObj.formatted_address.split(", ")[0],
        address2: "",
        administrativeDistrict: "",
        country: "",
        countryCode: "",
        formattedAddress: placeObj.formatted_address
          ? placeObj.formatted_address
          : "",
        latitude: String(placeObj.geometry.location.lat()),
        longitude: String(placeObj.geometry.location.lng()),
        municipality: "",
        name: placeObj.name ? placeObj.name : "",
        neighborhood: "",
        postalCode: ""
      };

      for (var value of placeObj.address_components) {
        if (value.types.includes("administrative_area_level_1")) {
          if (value.short_name) {
            result.administrativeDistrict = value.short_name;
          } else if (value.long_name) {
            result.administrativeDistrict = value.long_name;
          }
        }

        if (value.types.includes("country")) {
          if (value.short_name) {
            result.countryCode = value.short_name;
          }

          if (value.long_name) {
            result.country = value.long_name;
          }
        }

        if (value.types.includes("postal_code")) {
          if (value.long_name) {
            result.postalCode = value.long_name;
          } else if (value.short_name) {
            result.postalCode = value.short_name;
          }
        }

        if (value.types.includes("locality")) {
          if (value.long_name) {
            result.municipality = value.long_name;
          } else if (value.short_name) {
            result.municipality = value.short_name;
          }
        }

        if (value.types.includes("sublocality") && result.municipality === "") {
          if (value.long_name) {
            result.municipality = value.long_name;
          } else if (value.short_name) {
            result.municipality = value.short_name;
          }
        }

        if (value.types.includes("neighborhood")) {
          if (value.long_name) {
            result.neighborhood = value.long_name;
          } else if (value.short_name) {
            result.neighborhood = value.short_name;
          }
        }

        if (
          value.types.includes("colloquial_area") &&
          result.neighborhood === ""
        ) {
          if (value.long_name) {
            result.neighborhood = value.long_name;
          } else if (value.short_name) {
            result.neighborhood = value.short_name;
          }
        }
      }

      // console.log(result);

      return result;
    };
  }
};
